export default Object.freeze({
  REJ: 3,
  LOG: 4,
});
